import { useCallback, useState } from 'react';

export function useFormEditorContent() {
  const [showSectionSettings, setShowSectionSettings] = useState(false);
  const [showSubsectionSettings, setShowSubsectionSettings] = useState(false);

  const openSectionSettings = useCallback(() => setShowSectionSettings(true), []);
  const closeSectionSettings = useCallback(() => setShowSectionSettings(false), []);

  const openSubsectionSettings = useCallback(() => setShowSubsectionSettings(true), []);
  const closeSubsectionSettings = useCallback(() => setShowSubsectionSettings(false), []);

  return {
    showSectionSettings,
    showSubsectionSettings,
    openSectionSettings,
    closeSectionSettings,
    openSubsectionSettings,
    closeSubsectionSettings,
  };
}
